import React, { Component } from 'react';

import {
  RecipeSearch,
  withRecipesSubscription,
} from 'Common/Components/RecipeSearch';

class ProductionRecipeSearch extends Component {
  render() {
    return (
      <RecipeSearch
        {...this.props}
        enableDnD={false}
        showItemArrows={false}
      />
    );
  }
}

ProductionRecipeSearch = withRecipesSubscription(ProductionRecipeSearch);

export { ProductionRecipeSearch };



// WEBPACK FOOTER //
// ./src/pages/manageproduction/subpages/editproduction/components/ProductionRecipeSearch.js